import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { TIDS } from "@/constants/testIds";

const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="bg-white border-t border-[#E5E7EB]" data-testid={TIDS.footerSection}>
      <div className="zdc-container py-14 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-[10px] bg-[#111111] flex items-center justify-center">
                <div className="w-3 h-3 rounded-sm bg-[#2563EB]" />
              </div>
              <span className="font-display text-base font-semibold tracking-tight">Zuin Digital Consulting</span>
            </div>
            <p className="text-sm text-[#6B7280] max-w-sm leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-3 space-y-3">
            <div className="text-xs font-medium uppercase tracking-wider text-[#111111]">Navigazione</div>
            <ul className="space-y-2">
              {Object.entries(t.footer.links).map(([k, v]) => (
                <li key={k}>
                  <a
                    href={`#${k === "services" ? "services" : k === "packages" ? "pricing" : k === "about" ? "about" : "contact"}`}
                    className="text-sm text-[#6B7280] hover:text-[#2563EB] transition-colors"
                  >{v}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4 space-y-3">
            <div className="text-xs font-medium uppercase tracking-wider text-[#111111]">Contatti</div>
            <ul className="space-y-2 text-sm text-[#6B7280]">
              <li><span className="text-[#111111]">{t.footer.owner}:</span> Fabrizio Zuin</li>
              <li><span className="text-[#111111]">{t.footer.vat}:</span> 14776640964</li>
              <li>
                <span className="text-[#111111]">{t.footer.email}:</span>{" "}
                <a href="mailto:info@zuindigitalconsulting.it" className="hover:text-[#2563EB] transition-colors">
                  info@zuindigitalconsulting.it
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#E5E7EB] flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-[#6B7280]">
          <div>© 2026 Zuin Digital Consulting. {t.footer.rights}</div>
          <div className="flex items-center gap-4">
            <span>P. IVA 14776640964</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
